import React,{useState} from 'react'

export const SearchContext = React.createContext({
    query: "",
    handleSearchQuery: () => {},
  });


const SearchContextProvider = ({children}) => {
    const [query, setQuery] = useState('')
    
   const handleSearchQuery = (query) => {
    setQuery(query)
   }

  return (
    <SearchContext.Provider value={{ query: query, handleSearchQuery: handleSearchQuery }}>
        {children}
    </SearchContext.Provider>
  )
}

export default SearchContextProvider